// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"329":"1bf28f60","2367":"d663b977","2589":"d6fdf0fb"}[chunkId] + ".css";
};